var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParagraphEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H14V11H3V9ZM3 7H14V5H3V7ZM3 15H10V13H3V15ZM18.01 11.87L18.72 11.16C19.11 10.77 19.74 10.77 20.13 11.16L20.84 11.87C21.23 12.26 21.23 12.89 20.84 13.28L20.13 13.99L18.01 11.87ZM17.3 12.58L12 17.88V20H14.12L19.42 14.7L17.3 12.58Z",
    fill: "#C2D1FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphEdit);
export default __webpack_public_path__ + "static/media/paragraph-edit.91191885889c31551c73554327fe496a.svg";
export { ForwardRef as ReactComponent };